import { ILanguageCode } from '../interfaces/languageCode';
import { axiosAdmin } from './axios';
import { LANGUAGE_CODES_FETCH_PATH } from '../core/paths';

export namespace LanguageService {
  export function getCodes(): Promise<ILanguageCode[]> {
    return axiosAdmin.get(LANGUAGE_CODES_FETCH_PATH).then(({data}) => data );
  }
}